import { setTheme } from "theme/default/setTheme";

export const setColor_4d4d4d = setTheme(({ theme }) => `color: ${theme.colors.color_4d4d4d}`);
